<app-header></app-header>

<div class="banner-active">
  <div class="single-banner bg_cover" *ngFor="let slide of slideData;let i=index"
    [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
    <div class="banner-overlay">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="banner-content text-center">
              <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
              <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
              <p data-animation="fadeInLeft" data-delay="1.3s">{{slide?.description}} </p>
              <!-- <p>index = {{index}}</p> -->
              <div data-animation="fadeInLeft" data-delay="1.3s" *ngIf="i==0">
                <div class="assistance">
                  <i class="fal fa-fire"></i>
                  <span class="barre"></span>
                  <div>
                    <span class="assis">Assistance sinistre</span>
                    <a class="click" (click)="scroolDiv(declarationSinistre)">Cliquez ici</a>
                  </div>
                </div>
              </div>
              <button data-animation="fadeInUp" data-delay="1.6s" (click)="initForm()" *ngIf="i==0" class="main-btn" data-toggle="modal" data-target="#modalPlainte">Remonter une plainte</button>
            </div> <!-- banner content -->
          </div>
        </div> <!-- row -->
      </div> <!-- container -->
    </div>
  </div>
</div>

<div class="case-studies-area">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title">
          <h3 class="title title-besoin text-center">De quoi avez-vous besoin ? </h3>
          <h4 class="sub-title-besoin text-center"> Des solutions complètes, adaptées à vos besoins et proposées au
            meilleur prix </h4>
          <!-- <span [routerLink]="['/allocataire-details']">Voir tout <i class="fal fa-long-arrow-right"></i> </span> -->
        </div> <!-- section title -->
      </div>
    </div> <!-- row -->
  </div> <!-- container -->
  <div class="latest-services-area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" *ngFor="let item of besoins" data-wow-duration="1.5s"
          data-wow-delay="0s">
          <div class="single-services mt-30">
            <div class="services-thumb">
              <img [src]="item.img" alt="">
            </div>
            <div class="c-image">
              <svg viewBox="0 0 100 100"
                [ngClass]="{'c-voyage':item.title=='Voyage','isSafari':safariClass=='isSafari'}"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <image [attr.xlink:href]="item.subImg" x="0" y="0" />
              </svg>
            </div>
            <div class="services-content">
              <h4 class="title"> {{item.title}} </h4>
              <!-- <p>Les allocataires des Caisses d'Allocations Familiales sont les personnes qui perçoivent au moins une allocation en regard de leur situation familiale et/ou monétaire.</p> -->
              <a [routerLink]="item.btnUrl" (click)="getRoute('')"> <i class="fal fa-angle-right"></i> {{item.btnText}}
              </a>
            </div>
          </div> <!-- single services -->
        </div>
        <!-- <div class="plusOffr"><span class="fal fa-plus"></span> <a href="">Voir plus sur nos offres</a> </div> -->
      </div> <!-- row -->
    </div> <!-- container -->
  </div> <!-- containe fluid -->
</div>

<!-- <div class="contact-us-area bg_cover" #declarationSinistre>
  <div class="contact-overlay">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-details d-flex">
            <div class="contact-thumb wow slideInLeft" data-wow-duration=".5s" data-wow-delay="0s">
              <div class="contact-inc">
                <h4 class="title-inclu"> inclusive market</h4>
                <h2 class="title">L'assistance aux sinistres</h2>
                <span class="description">Remplissez le formulaire un de nos agents vous <br> contactera dans les plus
                  brefs délais</span>
              </div>
            </div>
            <div class="contact-form-area">
              <form [formGroup]="formSinistre">
                <div class="input-title">
                  <h3 class="title">Formulaire de déclaration sinistre</h3>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 pr-0">
                    <div class="success" *ngIf="sendMessage==1">
                      <i class="fal fa-check"></i>
                      <div class="message">
                        <span class="success-title">
                          Bravo !
                        </span>
                        <span class="success-descr">
                          Votre demande a été bien reçu avec succès. <br> Nos agents vous contacterons dans les plus
                          brefs délais.
                        </span>
                      </div>
                    </div>
                    <div class="danger" *ngIf="sendMessage==2">
                      <i class="fal fa-times"></i>
                      <div class="message">
                        <span class="success-title">
                          Oups !
                        </span>
                        <span class="success-descr">
                          Votre demande ne nous a pas bien été transmise. <br> Veuillez réessayer ou contact notre
                          hotline au +221 33 800 00 00.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="text" formControlName="nom" placeholder="Nom déclarant">
                      <img class="img-form" src="assets/images/nom.svg" alt="" popover="Nom déclarant" placement="top"
                        triggers="mouseenter:mouseleave">
                      <i class="barre"></i>
                    </div>
                    <div *ngIf="formSinistre.get('nom').errors">
                      <div
                        *ngIf="formSinistre.get('nom').errors.required && (formSinistre.get('nom').dirty || formSinistre.get('nom').touched || firstClick)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="text" formControlName="prenom" placeholder="Prénom déclarant">
                      <img class="img-form" popover="Prénom déclarant" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/nom.svg" alt="">
                      <i class="barre"></i>
                    </div>
                    <div *ngIf="formSinistre.get('prenom').errors">
                      <div
                        *ngIf="formSinistre.get('prenom').errors.required && (formSinistre.get('prenom').dirty || formSinistre.get('prenom').touched || firstClick)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="text" formControlName="adresse" placeholder="Adresse déclarant">
                      <img class="img-form" popover="Adresse déclarant" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/adresse.svg" alt="">
                      <i class="barre"></i>
                    </div>
                    <div *ngIf="formSinistre.get('adresse').errors">
                      <div
                        *ngIf="formSinistre.get('adresse').errors.required && (formSinistre.get('adresse').dirty || formSinistre.get('adresse').touched || firstClick)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box sinistre mt-30">
                      <input type="text"  formControlName="telephone"  matInput ng2TelInput
                        [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput (focus)="isFocus=true"
                        (blur)="isFocus=false" (hasError)="hasError($event,'telephone','formSinistre')" (countryChange)="onCountryChange($event)"
                        (ng2TelOutput)="getNumber($event,'telephone','formSinistre')"
                        (intlTelInputObject)="telInputObject($event)" />
                    </div>
                    <div *ngIf="formSinistre.get('telephone').errors">
                      <div
                        *ngIf="formSinistre.get('telephone').errors.required && (formSinistre.get('telephone').dirty || formSinistre.get('telephone').touched || firstClick)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                    <div class="text-red"
                      *ngIf="formSinistre.get('telephone').value && isFocus===false && hasPhoneError">
                      Le champs téléphone est invalide
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="text" formControlName="email" placeholder="Email déclarant">
                      <img class="img-email" popover="Email déclarant" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-email.svg" alt="">
                      <i class="barre"></i>
                    </div>
                    <div *ngIf="formSinistre.get('email').errors">
                      <div
                        *ngIf="formSinistre.get('email').errors.required && (formSinistre.get('email').dirty || formSinistre.get('email').touched || firstClick)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                      <div *ngIf="formSinistre.get('email').errors.pattern">
                        <div class="text-red">
                          Email est invalide
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="file" (change)="getFile($event)" accept=".pdf,.PDF,.png,.PNG,.JPG,.jpg,.JPEG,.jpeg"
                        multiple id="file" #fileSinistre hidden formControlName="fileSinistre"
                        placeholder="Fichier déclarant">
                      <img class="img-email" popover="Fichier déclarant" placement="top"
                        triggers="mouseenter:mouseleave" src="assets/images/icon-fonction.svg" alt="">
                      <i class="barre"></i>
                      <button (click)="fileSinistre.click()" class="choisirFile">Joindre pièces justificatifs </button>
                    </div>
                    <div class="filename">{{fileName}}</div>
                    <div *ngIf="formSinistre.get('fileSinistre').errors">
                      <div
                        *ngIf="formSinistre.get('fileSinistre').errors.required && (formSinistre.get('fileSinistre').dirty || formSinistre.get('fileSinistre').touched || firstClick)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-textarea mt-30">
                      <textarea formControlName="description" placeholder="Description du sinistre"></textarea>
                      <img class="img-form" popover="Description du sinistre" placement="top"
                        triggers="mouseenter:mouseleave" src="assets/images/icon-fonction.svg" alt="">
                      <i class="barre"></i>
                    </div>
                    <div *ngIf="formSinistre.get('description').errors">
                      <div
                        *ngIf="formSinistre.get('description').errors.required && (formSinistre.get('description').dirty || formSinistre.get('description').touched || firstClick)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <select formControlName="type">
                        <option value="" disabled selected>Type de sinistre</option>
                        <option [value]="item.id" *ngFor="let item of listSinistre"> {{item.libelle}}</option>
                      </select>
                      <img class="img-sinistre" popover="Type sinistre" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/sinistre.svg" alt="">
                      <i class="barre"></i>
                    </div>
                    <div *ngIf="formSinistre.get('type').errors">
                      <div
                        *ngIf="formSinistre.get('type').errors.required && (formSinistre.get('type').dirty || formSinistre.get('type').touched || firstClick)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0" *ngIf="formSinistre.get('type').value==listSinistre.length">
                    <div class="input-box mt-30">
                      <input type="text" formControlName="autre" placeholder="Autres types de sinistre">
                      <img class="img-form" popover="Autres types de sinistre" placement="top"
                        triggers="mouseenter:mouseleave" src="assets/images/sinistre.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>
                </div>
              </form>
              <div class="soumission" (click)="checkForm()">
                <img *ngIf="!loader" class="img-sou" src="assets/images/email2.svg" alt="">
                <i class="fal fa-spinner fa-pulse" *ngIf="loader"> </i>
                <span class="message">Soumettre le formulaire</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="contact-us-area bg_cover" #declarationSinistre>
  <div class="contact-overlay">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-details d-flex flex-column position-relative">
            <div class="trait"></div>
            <div class="d-flex justify-content-center w-100 zz">
              <div>
                <img src="assets/images/temoignage-1.png" alt="" class="imgForm">
              </div>
            </div>
            <div class="d-flex justify-content-center w-100 hvform" [formGroup]="sinistreForm">
              <div>
                <aw-wizard class="stepper-container bg-whtie pb-5" #wizard [navBarLocation]="'top'" [navBarLayout]="'large-empty'" [disableNavigationBar]="false">
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Bonjour ! Je suis Marilyne</span><br>
                      <span>Je suis là pour vous aider</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                    </div>
                    <div class="d-flex justify-content-center w-100">
                      <button class="btn btn-success but"  (click)="suivant()">C’est parti !!
                        <i class="fal fa-spinner fa-pulse" *ngIf="loaderVisible"></i>
                      </button>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Parlons un peu du contrat !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row d-flex justify-content-center">
                        <div class="col-lg-4 col-md-6 col-xs-12 col-sm-12">
                            <div class="semi">
                              <input type="text" name='numeroPolice' placeholder="Numéro de police" formControlName="numeroPolice">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/numero-passport.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                      </div>
                      <div class="text-bas">
                        Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" [disabled]="sinistreForm.get('numeroPolice').invalid" (click)="checkContrat()">Suivant
                              <i class="fal fa-spinner fa-pulse" *ngIf="loaderVisible"></i>
                            </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Parlons un peu du contrat !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row d-flex justify-content-around">
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <input type="text" name='numeroSinistre' placeholder="Numéro dossier" formControlName="numeroSinistre">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/numero-passport.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <input type="text" name='typeAssurance' placeholder="Type assurance" formControlName="typeAssurance" readonly>
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/icon-marque-auto.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6" *ngIf="sinistreForm.get('typeAssurance').value == 'AUTO'">
                            <div class="semi">
                              <input type="text" name='numImmat' placeholder="Numéro d'immatriculation" formControlName="numImmat">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/icon-marque-auto.svg" alt="">
                              <!-- <span  class="text-red-plus">*</span> -->
                              </span>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" (click)="suivant()" [disabled]="sinistreForm.get('numeroSinistre').invalid || sinistreForm.get('typeAssurance').invalid">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Parlons un peu de l'accident !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row d-flex justify-content-around">
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <input type="text" formControlName="dateAccident" #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name="date" placeholder="Date de l'accident">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-date.svg" alt="">
                                <span class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <input type="text" name='lieuAccident' placeholder="Lieu de l'accident" formControlName="lieuAccident">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/icon-adresse.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <input type="text" name='circonstance' placeholder="Causes et circonstances" formControlName="circonstance">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/icon-marque-auto.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" [disabled]="sinistreForm.get('dateAccident').invalid || sinistreForm.get('lieuAccident').invalid || sinistreForm.get('circonstance').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule" *ngIf=" sinistreForm.get('typeAssurance').value == 'AUTO'">
                    <div class="text">
                      <span>Parlons un peu du véhicule !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                            <div class="semi">
                              <input type="text" formControlName="dateVisitetechnik" #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name="date" placeholder="Date dernière visite">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-date.svg" alt="">
                                <span class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                            <div class="semi">
                              <input type="text" name='utilvehicul' placeholder="Usage du véhicule" formControlName="utilvehicul">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/icon-marque-auto.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" [disabled]="sinistreForm.get('dateVisitetechnik').invalid || sinistreForm.get('utilvehicul').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule" *ngIf=" sinistreForm.get('typeAssurance').value != 'AUTO'">
                    <div class="text">
                      <span>Parlons un peu du sinistre !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                            <div class="semi">
                              <ng-select formControlName="typeSinistre" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listTypeSinistre" bindLabel="name" bindValue="value" class="custom pp" placeholder="Type de sinistre"
                                  typeToSearchText="Taper pour rechercher">
                              </ng-select>
                              <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-marque-auto.svg" alt="">
                                <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                            <div class="semi">
                              <input type="text" formControlName="dateSinistre" #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name="date" placeholder="Date sinistre">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-date.svg" alt="">
                                <span class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" [disabled]="sinistreForm.get('typeSinistre').invalid || sinistreForm.get('dateSinistre').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Parlons un peu de vous !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                            <div class="semi">
                              <input type="text" name='prenomDeclarant' placeholder="Prénom" formControlName="prenomDeclarant">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/nom.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                            <div class="semi">
                              <input type="text" name='nomDeclarant' placeholder="Nom" formControlName="nomDeclarant">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/nom.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" [disabled]="sinistreForm.get('prenomDeclarant').invalid || sinistreForm.get('nomDeclarant').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Parlons un peu de vous !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                          <div class="semi">
                            <input type="text" formControlName="telephoneDeclarant" numberOnly class="input-tel" name='telephoneDeclarant' placeholder="Téléphone" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput (focus)="isFocus=true" (blur)="isFocus=false" (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                          <div class="semi">
                            <input type="email" name='email' placeholder="Email" formControlName="email">
                            <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                            <img src="assets/images/icon-email.svg" alt="">
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" [disabled]="sinistreForm.get('telephoneDeclarant').invalid || sinistreForm.get('email').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Quelques questions pour vous…</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform2 tt">
                      <div class="d-input2">
                        <div class="question">Un tiers est-il impliquer à l'accident ?</div>
                        <div class="div-radio">
                          <div class="">
                            <div class="">OUI</div>
                            <input class="t-radio" type="radio" formControlName="tiers" name="tiers" value="oui">
                          </div>
                          <div class="">
                            <div class="">NON</div>
                            <input class="t-radio" type="radio" formControlName="tiers" name="tiers" value="non">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" [disabled]="sinistreForm.get('tiers').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule" *ngIf="sinistreForm.get('tiers').value == 'oui' && sinistreForm.get('typeAssurance').value == 'AUTO'">
                    <div class="text">
                      <span>Parlons un peu de l'accident !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row d-flex justify-content-around">
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <input type="text" name='nomPropr' placeholder="Nom priopriétaire" formControlName="nomPropr">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/nom.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <input type="text" name='nomConduc' placeholder="Nom du conducteur" formControlName="nomConduc">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/nom.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <input type="text" name='immatProp' placeholder="Immatriculation" formControlName="immatProp">
                              <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                              <img src="assets/images/icon-marque-auto.svg" alt="">
                              <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but"  [disabled]="sinistreForm.get('nomPropr').invalid || sinistreForm.get('nomConduc').invalid || sinistreForm.get('immatProp').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule" *ngIf="sinistreForm.get('tiers').value == 'oui' && sinistreForm.get('typeAssurance').value == 'AUTO'">
                    <div class="text">
                      <span>Parlons un peu de l'accident !</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform1">
                      <div class="row d-flex justify-content-around">
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <ng-select formControlName="compagnie" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listesAssureurs" bindLabel="nom" bindValue="nom" class="custom pp" placeholder="Compagnie d'assurance"
                                  typeToSearchText="Taper pour rechercher">
                              </ng-select>
                              <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-marque-auto.svg" alt="">
                                <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <ng-select formControlName="marque" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listesMarque" bindLabel="make" bindValue="make" class="custom pp" placeholder="Marque du véhicule"
                                  typeToSearchText="Taper pour rechercher" (change)="marque()">
                              </ng-select>
                              <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-marque-auto.svg" alt="">
                                <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
                            <div class="semi">
                              <ng-select formControlName="modele" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listesModels" bindLabel="model" bindValue="model" class="custom pp" placeholder="Modèle du véhicule"
                                  typeToSearchText="Taper pour rechercher">
                              </ng-select>
                              <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-marque-auto.svg" alt="">
                                <span  class="text-red-plus">*</span>
                              </span>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but" [disabled]="sinistreForm.get('compagnie').invalid || sinistreForm.get('marque').invalid || sinistreForm.get('modele').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Quelques questions pour vous…</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform2 tt">
                      <div class="d-input2">
                        <div class="question">Existe-il de dommages matériels reliés à l'accident ?</div>
                        <div class="div-radio">
                          <div class="">
                            <div class="">OUI</div>
                            <input class="t-radio" type="radio" formControlName="domat" name="domat" value="oui">
                          </div>
                          <div class="">
                            <div class="">NON</div>
                            <input class="t-radio" type="radio" formControlName="domat" name="domat" value="non">
                          </div>
                        </div>
                      </div>
                      <div class="input-textarea" *ngIf="sinistreForm.get('domat').value == 'oui'">
                        <textarea id="story" name="story" placeholder="Dommages matériels"
                          formControlName="declaration">
                        </textarea>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn but"  [disabled]="sinistreForm.get('tiers').invalid" (click)="suivant()">Suivant
                                </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                  <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Vehicule">
                    <div class="text">
                      <span>Quelques questions pour vous…</span><br>
                      <span>En quelque min. Prêt(e)</span>
                    </div>
                    <div class="form-container formulaire1 hvform2 tt">
                      <div class="d-input2">
                        <div class="question">Existe-il de dommages corporels reliés à l'accident ?</div>
                        <div class="div-radio">
                          <div class="">
                            <div class="">OUI</div>
                            <input class="t-radio" type="radio" formControlName="domcorporel" name="domcorporel" value="oui">
                          </div>
                          <div class="">
                            <div class="">NON</div>
                            <input class="t-radio" type="radio" formControlName="domcorporel" name="domcorporel" value="non">
                          </div>
                        </div>
                      </div>
                      <div class="input-textarea" *ngIf="sinistreForm.get('domcorporel').value == 'oui'">
                        <textarea id="story" name="story" placeholder="Dommages corporels"
                          formControlName="declarationCorporel">
                        </textarea>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-30">
                        <div class="c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn but1" (click)="precedent()">Précédent</button>
                        </div>&nbsp;&nbsp;
                        <div class=" c-btnWidth">
                            <button type="button" class="btn btn-danger but1" (click)="annuler()">Annuler</button>
                        </div>&nbsp;&nbsp;
                        <div class="c-btnWidth">
                            <button class="btn btn-success but" (click)="soumettre()" [disabled]="sinistreForm.get('domcorporel').invalid">Soumettre
                              <i class="fal fa-spinner fa-pulse" *ngIf="loaderVisible"></i>
                            </button>
                        </div>
                    </div>
                  </aw-wizard-step>
                </aw-wizard>
              </div>
            </div>
            <!-- <div class="d-flex justify-content-center w-100 hvform" [formGroup]="sinistreForm">
              <div *ngIf="step == 0">
                <div class="text">
                  <span>Bonjour ! Je suis Marilyne</span><br>
                  <span>Je suis là pour vous aider</span>
                </div>
              </div>
              <div *ngIf="step == 1">
                <div class="text">
                  <span>Parlons un peu du contrat !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div>
                    <input type="text" class="form-control" placeholder="Numéro contrat" formControlName="numeroPolice">
                  </div>
                </div>
                <div class="text-bas">
                  Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                </div>
              </div>
              <div *ngIf="step == 2">
                <div class="text">
                  <span>Parlons un peu du contrat !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div>
                    <input type="text" class="form-control" placeholder="Numéro dossier" formControlName="numeroSinistre">
                  </div>
                  <div>
                    <input type="text" class="form-control" placeholder="Type assurance" formControlName="typeAssurance" readonly>
                  </div>
                  <div *ngIf="sinistreForm.get('typeAssurance').value == 'AUTO'">
                    <input type="text" class="form-control" placeholder="Numéro immatriculation" formControlName="numImmat">
                  </div>
                </div>
                <div class="text-bas">
                  Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                </div>
              </div>
              <div *ngIf="step == 3">
                <div class="text">
                  <span>Parlons un peu du contrat !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div>
                    <input type="date" class="form-control" placeholder="Date de l'accident" formControlName="dateAccident">
                  </div>
                  <div>
                    <input type="text" class="form-control" placeholder="Lieu de l'accident" formControlName="lieuAccident">
                  </div>
                  <div>
                    <input type="text" class="form-control" placeholder="Causes et circonstances" formControlName="circonstance">
                  </div>
                </div>
                <div class="text-bas">
                  Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                </div>
              </div>
              <div *ngIf="step == 4 && sinistreForm.get('typeAssurance').value == 'AUTO'">
                <div class="text">
                  <span>Parlons un peu du véhicule !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div>
                    <input type="date" class="form-control" placeholder="Date dernière visite" formControlName="dateVisitetechnik">
                  </div>
                  <div>
                    <input type="text" class="form-control" placeholder="Usage du véhicule" formControlName="utilvehicul">
                  </div>
                </div>
                <div class="text-bas">
                  Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                </div>
              </div>
              <div *ngIf="step == 4 && sinistreForm.get('typeAssurance').value != 'AUTO'">
                <div class="text">
                  <span>Parlons un peu du véhicule !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div class="div-w">
                    <ng-select clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listTypeSinistre" bindLabel="name" bindValue="value" class="custom" placeholder="" typeToSearchText="Taper pour rechercher" formControlName="typeSinistre">
                    </ng-select>
                  </div>
                  <div>
                    <input type="date" class="form-control" placeholder="Date sinistre" formControlName="dateSinistre">
                  </div>
                </div>
                <div class="text-bas">
                  Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                </div>
              </div>
              <div *ngIf="step == 5">
                <div class="text">
                  <span>Parlons un peu de vous !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div>
                    <input type="text" class="form-control" placeholder="Prénom" formControlName="prenomDeclarant">
                  </div>
                  <div>
                    <input type="text" class="form-control" placeholder="Nom" formControlName="nomDeclarant">
                  </div>
                </div>
                <div class="text-bas">
                  Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                </div>
              </div>
              <div *ngIf="step == 6">
                <div class="text">
                  <span>Parlons un peu de vous !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div>
                    <input type="text" numberOnly class="input-tel tel" name="Téléphone" formControlName="telephoneDeclarant"
                    placeholder="Téléphone" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                    (countryChange)="onCountryChange($event)" />
                  </div>
                  <div>
                    <input type="email" class="form-control" placeholder="Email" formControlName="email">
                  </div>
                </div>
                <div class="text-bas">
                  Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                </div>
              </div>
              <div *ngIf="step == 7">
                <div class="text">
                  <span>Quelques questions pour vous…</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input2">
                    <div class="question">Existe-il de dommages matériels reliés à l'accident ?</div>
                    <div class="div-radio">
                      <div class="">
                        <div class="">OUI</div>
                        <input class="t-radio" type="radio" formControlName="domat" name="domat" value="oui">
                      </div>
                      <div class="">
                        <div class="">NON</div>
                        <input class="t-radio" type="radio" formControlName="domat" name="domat" value="non">
                      </div>
                    </div>
                </div>
                <div class="input-textarea" *ngIf="sinistreForm.get('domat').value == 'oui'">
                  <textarea id="story" name="story" placeholder="Dommages matériels"
                    formControlName="declaration">
                  </textarea>
                </div>
              </div>
              <div *ngIf="step == 8">
                <div class="text">
                  <span>Quelques questions pour vous…</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input2">
                    <div class="question">Existe-il de dommages corporels reliés à l'accident ?</div>
                    <div class="div-radio">
                      <div class="">
                        <div class="">OUI</div>
                        <input class="t-radio" type="radio" formControlName="domcorporel" name="domcorporel" value="oui">
                      </div>
                      <div class="">
                        <div class="">NON</div>
                        <input class="t-radio" type="radio" formControlName="domcorporel" name="domcorporel" value="non">
                      </div>
                    </div>
                </div>
                <div class="input-textarea" *ngIf="sinistreForm.get('domcorporel').value == 'oui'">
                  <textarea id="story" name="story" placeholder="Dommages corporels"
                    formControlName="declarationCorporel">
                  </textarea>
                </div>
              </div>
              <div *ngIf="step == 9">
                <div class="text">
                  <span>Quelques questions pour vous…</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input1">
                    <div class="question">Un tiers est-il impliquer à l'accident ?</div>
                    <div class="div-radio">
                      <div class="">
                        <div class="">OUI</div>
                        <input class="t-radio" type="radio" formControlName="tiers" name="tiers" value="oui" (change)="change()">
                      </div>
                      <div class="">
                        <div class="">NON</div>
                        <input class="t-radio" type="radio" formControlName="tiers" name="tiers" value="non" (change)="change()">
                      </div>
                    </div>

                </div>
              </div>
              <div *ngIf="step == 10 && sinistreForm.get('tiers').value == 'oui' && sinistreForm.get('typeAssurance').value == 'AUTO'">
                <div class="text">
                  <span>Causes et circontances de l'accident !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div>
                    <input type="text" class="form-control" placeholder="Nom priopriétaire" formControlName="nomPropr">
                  </div>
                  <div>
                    <input type="text" class="form-control" placeholder="Nom conducteur" formControlName="nomConduc">
                  </div>
                  <div>
                    <input type="text" class="form-control" placeholder="Immatriculation" formControlName="immatProp">
                  </div>
                </div>
                <div class="text-bas">
                  Les données collectées seront uniquement utilisées pour vous proposer des garanties adaptées et au meilleur prix.
                </div>
              </div>
              <div *ngIf="step == 11 && sinistreForm.get('tiers').value == 'oui' && sinistreForm.get('typeAssurance').value == 'AUTO'">
                <div class="text">
                  <span>Causes et circontances de l'accident !</span><br>
                  <span>En quelque min. Prêt(e)</span>
                </div>
                <div class="d-input">
                  <div class="div-w">
                    <div for="compagnie">Compagnie d'assurance</div>
                    <ng-select id="compagnie" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listesAssureurs" bindLabel="nom" bindValue="nom" class="custom" placeholder="Compagnie d'assurance" typeToSearchText="Taper pour rechercher" formControlName="compagnie">
                    </ng-select>
                  </div>
                  <div class="div-w">
                    <div for="marque">Marque du vehicule</div>
                    <ng-select id="marque" (change)="marque()" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listesMarque" bindLabel="make" bindValue="make" class="custom" placeholder="Marque du vehicule" typeToSearchText="Taper pour rechercher" formControlName="marque">
                    </ng-select>
                  </div>
                  <div class="div-w">
                    <div for="model">Modèle du vehicule</div>
                    <ng-select id="model" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listesModels" bindLabel="model" bindValue="model" class="custom" placeholder="Modèle du vehicule" typeToSearchText="Taper pour rechercher" formControlName="modele">
                    </ng-select>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <div class="d-flex justify-content-center w-100">
              <button class="btn btn-warning but1" [disabled]="loaderVisible" *ngIf="step > 0" (click)="precStep()">Précedent</button> &nbsp;&nbsp;
              <button class="btn btn-danger but1" [disabled]="loaderVisible" *ngIf="step > 0" (click)="cancel()">Annuler</button> &nbsp;&nbsp;
              <button class="btn btn-success but" (click)="nextStep()" *ngIf="step != maxStep">{{titleButton}}
                <i class="fal fa-spinner fa-pulse" *ngIf="loaderVisible"></i>
              </button>
              <button class="btn btn-success but" (click)="soumettre()" *ngIf="step == maxStep">Soumettre
                <i class="fal fa-spinner fa-pulse" *ngIf="loaderVisible"></i>
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="case-studies-area">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title">
          <h3 class="title title-besoin text-center">Profitez des avantages exceptionnels ! </h3>
          <!-- <h3 class="sub-title-besoin text-center"> Des solutions complètes , adaptées à vos besoins et proposées au meilleur prix </h3> -->
          <!-- <span [routerLink]="['/allocataire-details']">Voir tout <i class="fal fa-long-arrow-right"></i> </span> -->
        </div> <!-- section title -->
      </div>
    </div> <!-- row -->
  </div> <!-- container -->
  <div class="latest-services-area mb-0">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" *ngFor="let item of avantages" data-wow-duration="1.5s"
          data-wow-delay="0s">
          <div class="single-services mt-30 mb-55">
            <div class="services-thumb">
              <img [src]="item.img" alt="">
            </div>
            <div class="c-image">
              <svg viewBox="0 0 100 100" [ngClass]="{'isSafari':safariClass=='isSafari'}"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <image [attr.xlink:href]="item.subImg" x="0" y="0" />
              </svg>
            </div>
            <div class="services-content">
              <h4 class="title"> {{item.title}} </h4>
              <!-- <p>Les allocataires des Caisses d'Allocations Familiales sont les personnes qui perçoivent au moins une allocation en regard de leur situation familiale et/ou monétaire.</p> -->
              <a> </a>
            </div>
          </div> <!-- single services -->
        </div>
      </div> <!-- row -->
    </div> <!-- container -->
  </div> <!-- containe fluid -->
</div>

<div class="brand-2-area pb-60 mr-200 ml-200">
  <div class="title-conf">Ils nous font confiance </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="brand-active">
          <div class="brand-item" *ngFor="let item of partenaires">
            <img [src]="item.img" alt="brand name">
          </div>

        </div> <!-- brand item -->
      </div>
    </div> <!-- row -->
  </div> <!-- container -->
</div>

<div class="relation">
  <div class="row">
    <div class="col-md-4 col-sm-4" *ngFor="let item of relations">
      <div [class]="item.class">
        <img [src]="item.img" alt="">
      </div>
      <div class="title" [innerHTML]="item.title">
      </div>
    </div>
  </div>
</div>
<div class="brand-2-area temoignage pb-120 pt-120 ">
  <div class="title-conf">Témoignages des clients </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hidden-xs">
        <div class="brand-active">
          <div class="brand-item" *ngFor="let item of temoignages">
            <img class="img-temoi" [src]="item.img" alt="brand name">
            <div class="description" [innerHTML]="item.description">
              <!-- {{item.description}} -->
            </div>
            <div class="nom">
              {{item.nom}} <b> {{item.poste}} </b>
            </div>
            <div class="image">
              <img [src]="item.icon" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="relation2">
  <img class="img-letter" src="assets/images/newsletter.svg" alt="">
  <div class="letter-title">
    Newsletter
  </div>
  <span class="letter-descr">
    Abonnez-vous à notre bulletin pour bénéficier <br> de nos offres et services
  </span>
  <div class="letter-message">
    <div class="input-box mt-30">
      <input type="text" (blur)="validateEmail()" [(ngModel)]="email" placeholder="Veuillez saisir votre adresse mail">
      <img class="icon" *ngIf="!loader" src="assets/images/email.svg" alt="">
      <span class="icon" *ngIf="loader">
        <i class="fal fa-spinner"></i>
      </span>
      <!-- <i class="fal fa-envelope-open"></i> -->
      <div *ngIf="!validEmail" class="error-input mr-200 mt-10">
        <div class="text-red">
          Ce champs est invalide
        </div>
      </div>
    </div>

  </div>
</div>
<div class="modal" id="modalPlainte" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Remonter une plainte suite à votre parcours de soins</h5>
        <button #closeBTN type="button" class="close" (clikc)='firstClick=false;' data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="formulaire no-margin">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-6 col-xs-12">
              <form [formGroup]="formPlainte">
                <div *ngFor="let item of fieldsPlainte">
                  <div class="input-box" *ngIf="item.type=='text' && !item?.chieldOther">
                    <input type="text" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='text' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" value="{{formPlainte.get(item.field).value}}" readonly name={{item.field}}
                        [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="item.type=='textarea' && !item?.chieldOther" class="input-area">
                    <label class="label-textarea"> {{item.label}} </label>
                    <div class="input-textarea">
                      <textarea name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label"></textarea>
                    </div>
                  </div>
                  <div *ngIf="item.type=='textarea' && item?.chieldOther">
                    <div class="input-area"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <label class="label-textarea"> {{item.label}} </label>
                      <div class="input-textarea">
                        <textarea name={{item.field}} [formControlName]="item.field"
                          [placeholder]="item.label"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='number'  && !item?.chieldOther">
                    <input type="number" numberOnly min="0" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='number'  && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="number" numberOnly min="0" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>


                  <div class="input-box" *ngIf="item.type=='montant' && !item?.chieldOther">
                    <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='montant' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='tel' && !item?.chieldOther ">
                    <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                      (focus)="isFocus=true" (blur)="isFocus=false"
                      (hasError)="hasError($event,item.field,'formPlainte')"
                      (ng2TelOutput)="getNumber($event,item.field,'formPlainte')"
                      (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                  </div>

                  <div *ngIf="item.type=='tel' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                        (focus)="isFocus=true" (blur)="isFocus=false"
                        (hasError)="hasError($event,item.field,'formPlainte')"
                        (ng2TelOutput)="getNumber($event,item.field,'formPlainte')"
                        (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                    </div>
                  </div>
                  <div *ngIf="item.type=='tel' && formPlainte.get(item.field).value && isFocus===false && hasPhoneError"
                    class="text-red">
                    {{item.label}} est invalide
                  </div>
                  <div class="input-box" *ngIf="item.type=='email' && !item?.chieldOther">
                    <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='email' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>

                  <div class="input-box" *ngIf="item.type=='date' && !item?.chieldOther">
                    <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                      (bsValueChange)="checkDate($event,item.field,'formPlainte')"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='date' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                        [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='dateNaiss' && !item?.chieldOther">
                    <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                      (bsValueChange)="checkDate($event,item.field,'formPlainte')"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='dateNaiss' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                        [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>

                  <div class="input-box" *ngIf="item.type=='select' && !item?.chieldOther">
                    <select name={{item.field}} [formControlName]="item.field">
                      <option value="" disabled selected> {{item.label}} </option>
                      <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                    </select>
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='select' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <select name={{item.field}} [formControlName]="item.field">
                        <option value="" disabled selected> {{item.label}} </option>
                        <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                      </select>
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="error-input" *ngFor="let validation of item.validations;">
                    <div
                      *ngIf="formPlainte.get(item.field).invalid && (formPlainte.get(item.field).dirty || formPlainte.get(item.field).touched || firstClick)">
                      <div class="text-red" *ngIf="formPlainte.get(item.field).hasError(validation.name) ">
                        {{validation.message}}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="plainteBtn">
          <button class="btn btn-danger" [disabled]="loader"
            data-dismiss="modal">Annuler</button> &nbsp;&nbsp;
          <button class="btn btn-success" [disabled]="loader" (click)="checkFormPlainte()"> <i
              class="fal fa-spinner fa-pulse" *ngIf="loader"></i> &nbsp; Envoyer</button>
        </div>
      </div>
    </div>
  </div>
</div>
<swal #confirmSwalLetter title="Etes-vous sûr de vouloir souscrire à notre new letters" text="" icon="question"
  [showCancelButton]="true" [confirmButtonText]="'Valider'" [cancelButtonText]="'Annuler'" [showLoaderOnConfirm]="true"
  [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="saveLetters()">
</swal>
<swal #confirmSwal title="Voulez-vous confirmer votre déclaration de sinistre" text="" icon="question"
  [showCancelButton]="true" [reverseButtons]="true" [confirmButtonText]="'Valider'" [cancelButtonText]="'Annuler'" [showLoaderOnConfirm]="true"
  [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="enregisterSinistre()">
</swal>
<swal #confirmSwalPlainte title="Voulez-vous confirmer votre plainte" text="" icon="question" [showCancelButton]="true"
  [confirmButtonText]="'Valider'" [cancelButtonText]="'Annuler'" [showLoaderOnConfirm]="true" [allowEscapeKey]="false"
  [allowOutsideClick]="false" (confirm)="savePlainte()">
</swal>
<app-footer></app-footer>
